/** Mirrors the backend `PortalAccount.MaxIdentityDocument*Length` column widths. */
export const IdentityDocumentMaxLength = {
  number: 50,
  issuingAuthority: 100,
};

/** The ID-document details (Ausweisdaten) entered with the initial activation; every field is optional. */
export interface IdentityDocumentFormValues {
  type: string | null;
  number: string;
  issuingAuthority: string;
  validUntil: Date | null;
}
